import { getPreviewLabels } from './helpers';

export const getUserAccountLoginText = getPreviewLabels(
  'client.header.login.button'
);
export const getUserAccountLogoutText = getPreviewLabels(
  'client.header.logout.button'
);
